<script>
import moment from "moment";
import axios from '@/utils/axios';
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import DateRangePicker from "daterangepicker";
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";

export default {
  inject: ['setLoading'],
  components: {
    Vue3ChartJs,
  },
  data() {
    return {
      errors: {},  
      errors: {},
      title: "Reports",
      text: "User Detailed Report",
      text1: "Reports",
      isCollapsed: false,
      app_currency: '',
      filter: {
        user: '',
        from_date: '',
        to_date: '',
      },
      users: [],
      data: [],
      searchText: '',
      columns: [
      {
        title: 'S.No',
        dataIndex: 'SNo',
        key: 'SNo',
      },
      {
        title: 'User Name',
        dataIndex: 'UserName',
        key: 'UserName',
      },
      {
        title: 'Total Leads',
        dataIndex: 'TotalLeads',
        key: 'TotalLeads',
      },
      {
        title: 'Total Customers',
        dataIndex: 'TotalCustomers',
        key: 'TotalCustomers',
      },
      {
        title: 'Total Quotations',
        dataIndex: 'TotalQuotations',
        key: 'TotalQuotations',
      },
      {
        title: 'Total Quotation Requests',
        dataIndex: 'TotalQuotationRequests',
        key: 'TotalQuotationRequests',
      },
      {
        title: 'Total Quotation Amount',
        dataIndex: 'TotalQuotationAmount',
        key: 'TotalQuotationAmount'
      },
      {
        title: 'Total Proforma Invoice',
        dataIndex: 'TotalProforma',
        key: 'TotalProforma',
      },
      {
        title: 'Total Proforma Invoice Amount',
        dataIndex: 'TotalProformaAmount',
        key: 'TotalProformaAmount'
      }
      ],
      rowSelection: null,
    };
  },

  computed: {
   filteredData() {
    if (!this.searchText) return this.data;
    const search = this.searchText.toLowerCase();
    return this.data.filter(item => item.name?.toLowerCase().includes(search));
   },
  },

  async mounted() {
    this.getUsers();
    this.app_currency = await this.$appCurrency();

    const start = moment().subtract(6, "days");
    const end = moment();

    new DateRangePicker(
      this.$refs.dateRangeInput,
      {
        startDate: start,
        endDate: end,
        locale: {
         format: "DD/MM/YYYY",
         separator: " - "
        },
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        }
      },
      (start, end) => {
        this.setDateRange(start, end);
      },
      this.booking_range
    );
    // Initialize filter date range as soon as picker mounts
    this.setDateRange(start, end);

    //LOAD DATA
    this.filterReport();
  },

  methods: {

    exportCSV() {
 if (!this.filteredData.length) {
  this.$swalToast('No data to export', 'warning');
  return;
 }

 const headers = [
  'S.No',
  'User Name',
  'Total Leads',
  'Total Customers',
  'Total Quotations',
  'Total Quotation Requests',
  'Total Quotation Amount',
  'Total Proforma Invoice',
  'Total Proforma Invoice Amount'
 ];

 const rows = this.filteredData.map((record, index) => [
  index + 1,
  record.user_name,
  record.total_leads,
  record.total_customers,
  record.total_quotations,
  record.total_quotation_requests,
  `${this.app_currency.code} ${record.total_quotation_amount}`,
  record.total_proforma,
  `${this.app_currency.code} ${record.total_proforma_amount}`
 ]);

 const csvContent = [headers, ...rows]
  .map(row => row.map(val => `"${String(val ?? '').replace(/"/g, '""')}"`).join(','))
  .join('\n');

 const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
 const url = URL.createObjectURL(blob);

 const link = document.createElement('a');
 link.href = url;
 link.download = `user_detailed_report_${this.filter.from_date}_to_${this.filter.to_date}.csv`;
 document.body.appendChild(link);
 link.click();
 document.body.removeChild(link);
 URL.revokeObjectURL(url);
},


    booking_range(start, end) {
     return start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");
    },

    setDateRange(start, end) {
     this.filter.from_date = start.format("YYYY-MM-DD");
     this.filter.to_date = end.format("YYYY-MM-DD");
    },

    async filterReport() {
      this.errors = {};  
      this.setLoading(true);
      try{
       const payload = {
        user_id: this.filter.user,
        from_date: this.filter.from_date,
        to_date: this.filter.to_date
       };
       const query_string = new URLSearchParams(payload).toString(); 
       const response = await axios.get(`/reports/user/detailed?${query_string}`);
       this.data = response.data.data;

      }catch(error){
       if(error.type == 'validation'){
        this.errors = error.errors;
       }else{
        this.$swalToast(error.message, 'error');
       }
      }finally{
       this.setLoading(false);
      }
    },

    async getUsers() {
     this.setLoading(true);
     try{
      const response = await axios.get('/users/all-users');
      this.users = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    clearFilter() {
     this.filter = {
      user: ''
     };
     this.filterReport();
      // Optionally reset date picker UI too
      // (e.g., manually set this.$refs.dateRangeInput.value)
    }
  }
};
</script>


<template>
 <layout-header></layout-header>
 <layout-sidebar></layout-sidebar>
<div class="page-wrapper">
<div class="content">
<!-- Breadcrumb -->
<div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
 <breadcrumb :title="title" :text="text" :text1="text1" />
<div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
  <div class="me-2 mb-2">
 <button type="button" class="btn btn-outline-primary d-inline-flex align-items-center" @click="exportCSV">
  <i class="ti ti-file-export me-1"></i>Export CSV
 </button>
</div>
<!-- <div class="me-2 mb-2">
<div class="dropdown">
<a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center" data-bs-toggle="dropdown">
 <i class="ti ti-file-export me-1"></i>Export </a>
<ul class="dropdown-menu dropdown-menu-end p-3">
 <li>
  <a href="javascript:void(0);" class="dropdown-item rounded-1"><i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a>
 </li>
 <li>
  <a href="javascript:void(0);" class="dropdown-item rounded-1"><i class="ti ti-file-type-xls me-1"></i>Export as Excel</a>
 </li>
</ul>
 </div>
</div> -->
<!-- <div class="mb-2">
<div class="input-icon w-120 position-relative">
 <span class="input-icon-addon"> 
  <i class="ti ti-calendar text-gray-9"></i>
 </span>
 <a-date-picker class="form-control yearpicker" picker="year" value="2025" placeholder="2025" />
</div>
</div> -->
<div class="ms-2 head-icons">
 
</div>
</div>
</div>
<!-- /Breadcrumb -->

<div class="card border-0">
<div class="card-body d-flex align-items-center justify-content-center flex-wrap pb-1">
  <div class="d-flex align-items-center flex-wrap mb-1">
   
   <div class="me-3" v-if="filter.user !== '' ">
     <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
    </div>  

    <div class="me-3">
     <div class="input-icon-end position-relative">
      <input type="text" class="form-control date-range bookingrange" ref="dateRangeInput" placeholder="dd/mm/yyyy - dd/mm/yyyy">
      <span class="input-icon-addon"><i class="ti ti-chevron-down"></i></span>
     </div>
    </div>

    <div class="me-3">
     <select class="form-select" v-model="filter.user">
      <option value="">User</option>
      <option :value="row.id" v-for="row in users" :key="row.id">{{row.name}}</option>
     </select>
     <div class="text-danger small mt-1" v-if="errors.user_id">{{ errors.user_id[0] }}</div>
    </div>

    <div class="me-3">
     <button type="button" class="btn btn-dark" @click="filterReport"><i class="ti ti-search"></i></button>
    </div>
   
  </div>
</div>
</div>

 <div class="row">
  <div class="col-lg-12">
<div class="custom-datatable-filter table-responsive">

<a-table v-if="filteredData.length" class="table datatable thead-light" :columns="columns" :data-source="filteredData"
  :row-selection="rowSelection">
  <template #bodyCell="{ column, record, index }">
    
    <template v-if="column.key === 'SNo'"> {{ index + 1 }}. </template>   
    
    <template v-if="column.key === 'UserName'">
     <h6 class="fs-14 fw-medium"> {{ record.user_name }} </h6>
    </template>

    <template v-if="column.key === 'TotalLeads'">
     <h6 class="fs-14 fw-medium"> 
     <a class="text-primary" v-if="record.total_leads > 0" href="javascript:void(0);" data-bs-target="#report_lead_modal" data-bs-toggle="modal" @click="$refs.reportModal.getUserLeads(record.user_id, filter.from_date, filter.to_date);"> {{ record.total_leads }} </a>
     <span v-else class="text-muted">{{ record.total_leads }}</span> 
    </h6>
    </template>

    <template v-if="column.key === 'TotalCustomers'">
     <h6 class="fs-14 fw-medium"> 
     <a class="text-primary" v-if="record.total_customers > 0" href="javascript:void(0);" data-bs-target="#report_customer_modal" data-bs-toggle="modal" @click="$refs.reportModal.getUserCustomers(record.user_id, filter.from_date, filter.to_date);"> {{ record.total_customers }} </a>
    <span v-else class="text-muted">{{ record.total_customers }}</span>
    </h6>
    </template>

    <template v-if="column.key === 'TotalQuotations'">
     <h6 class="fs-14 fw-medium"> 
     <a class="text-primary" v-if="record.total_quotations > 0" href="javascript:void(0);" data-bs-target="#report_quotation_modal" data-bs-toggle="modal" @click="$refs.reportModal.getUserQuotations(record.user_id, filter.from_date, filter.to_date);"> {{ record.total_quotations }} </a>
    <span v-else class="text-muted">{{ record.total_quotations }}</span>
    </h6>
    </template>

    <template v-if="column.key === 'TotalQuotationRequests'">
      <h6 class="fs-14 fw-medium"> 
      <a class="text-primary" v-if="record.total_quotation_requests > 0" href="javascript:void(0);" data-bs-target="#report_quotation_request_modal" data-bs-toggle="modal" @click="$refs.reportModal.getUserQuotationRequests(record.user_id, filter.from_date, filter.to_date);"> {{ record.total_quotation_requests }} </a>
      <span v-else class="text-muted">{{ record.total_quotation_requests }}</span>
      </h6>
    </template>

    <template v-if="column.key === 'TotalQuotationAmount'">
     <h6 class="fs-14 fw-medium"> {{ app_currency.code }} {{ record.total_quotation_amount }} </h6>
    </template>

    <template v-if="column.key === 'TotalProforma'">
     <h6 class="fs-14 fw-medium"> 
     <a class="text-primary" v-if="record.total_proforma > 0" href="javascript:void(0);" data-bs-target="#report_proforma_modal" data-bs-toggle="modal" @click="$refs.reportModal.getUserProforma(record.user_id, filter.from_date, filter.to_date);"> {{ record.total_proforma }} </a>
    <span v-else class="text-muted">{{ record.total_proforma }}</span>
    </h6>
    </template>

    <template v-if="column.key === 'TotalProformaAmount'">
     <h6 class="fs-14 fw-medium"> {{ app_currency.code }} {{ record.total_proforma_amount }} </h6>
    </template>
    
  </template>
</a-table>

<div v-else class="p-3 text-center text-muted">
  No records found.
</div>

</div>
  </div>  
 </div>


</div>

<app-footer></app-footer>

</div>

<user-report-modal ref="reportModal"></user-report-modal>
</template>
<style scoped>
.table-responsive {
  overflow-y: auto;
}
</style>